const ASSIST_DRIP_DISMISS_STORAGE_KEY_PREFIX = 'assistDripProposalDismissed'
const ASSIST_DRIP_DISMISS_DAYS = 7

const getStorageKey = subsidiaryId => `${ASSIST_DRIP_DISMISS_STORAGE_KEY_PREFIX}-${subsidiaryId}`

export const isAssistDripProposalDismissed = subsidiaryId => {
  if (!subsidiaryId) {
    return false
  }

  try {
    const raw = localStorage.getItem(getStorageKey(subsidiaryId))
    if (!raw) {
      return false
    }

    const dismissedUntil = Number(raw)
    if (!Number.isFinite(dismissedUntil)) {
      localStorage.removeItem(getStorageKey(subsidiaryId))
      return false
    }

    if (Date.now() < dismissedUntil) {
      return true
    }

    localStorage.removeItem(getStorageKey(subsidiaryId))
    return false
  } catch (e) {
    return false
  }
}

export const dismissAssistDripProposal = (
  subsidiaryId,
  dismissDays = ASSIST_DRIP_DISMISS_DAYS
) => {
  if (!subsidiaryId) {
    return
  }

  try {
    const dismissedUntil = Date.now() + dismissDays * 24 * 60 * 60 * 1000
    localStorage.setItem(getStorageKey(subsidiaryId), String(dismissedUntil))
  } catch (e) {
    // localStorage unavailable — proposal may show again on next visit
  }
}

export const clearAssistDripProposalDismiss = subsidiaryId => {
  if (!subsidiaryId) {
    return
  }

  try {
    localStorage.removeItem(getStorageKey(subsidiaryId))
  } catch (e) {
    // localStorage unavailable
  }
}

export { ASSIST_DRIP_DISMISS_DAYS }
